module.exports = __webpack_public_path__ + "assets/img/AppIcon.a36014f6.png";